import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css'],
})
export class LandingComponent implements OnInit {
  isBrowser: boolean;
  private header: HTMLElement | null = null;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      // If user is already logged in, redirect to home
      try {
        const token = localStorage.getItem('accessToken');
        if (token) {
          const userInfoRaw = localStorage.getItem('userInfo');
          if (userInfoRaw) {
            const userInfo = JSON.parse(userInfoRaw);
            const role = userInfo?.role;
            const roleName = typeof role === 'object' && role !== null ? role.name : role;
            if (roleName?.toString().toUpperCase() === 'COMPANY') {
              this.router.navigate(['/company-home']);
            } else {
              this.router.navigate(['/home']);
            }
            return;
          }
        }
      } catch {}

      if (typeof document !== 'undefined') {
        this.header = document.querySelector('.header');
      }
      window.onscroll = () => {
        if (this.header) {
          if (window.scrollY > 30) {
            this.header.classList.add('scrolled');
          } else {
            this.header.classList.remove('scrolled');
          }
        }
      };
    }
  }



  navigateTo(path: string): void {
    this.router.navigateByUrl(path);
  }
}
